import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { PublisherCollectingSocietyView } from "./PublisherCollectingSocietyView";
import { PublisherCollectingSocietyViewStore } from "../../store/PublisherCollectingSocietyViewStore";
import { useStore } from "../../../../hooks";

export const PublisherCollectingSocietyViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/publisherCollectingSociety/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new PublisherCollectingSocietyViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <PublisherCollectingSocietyView
          publisherCollectingSocietyViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
